import React from "react";

const marks = {
  simplestores: "SS",
  shopify: "SH",
  wix: "W",
  woocommerce: "WC",
  bigcommerce: "BC",
  squarespace: "SP",
  ecwid: "E",
  "square-online": "SQ",
  hostinger: "H",
  godaddy: "GD",
};

const PlatformLogo = ({ platform, size = 32, rounded = "rounded-md" }) => (
  <div
    role="img"
    aria-label={`${platform.name} mark`}
    className={`${rounded} flex shrink-0 items-center justify-center border border-black/10 font-bold text-white`}
    style={{
      width: size,
      height: size,
      backgroundColor: platform.color || "#334155",
      fontSize: Math.max(9, size * 0.34),
    }}
  >
    {marks[platform.slug] || platform.name.charAt(0)}
  </div>
);

export default PlatformLogo;